export { composeEventHandlers } from './primitive';
